// customization:
// conditional render of description

import React from 'react';
import { PageActions } from '@redturtle/iovisit-theme/components/Views';
import { notLRF } from '@redturtle/iovisit-theme/config/slots';
import config from '@plone/registry';

const PageHeader = ({ content }) => {
  return (
    <div className="page-header">
      <div className="page-header-title">
        <h1 className="documentFirstHeading">{content?.title}</h1>
        {(content?.show_share_links || notLRF({ content })) && (
          <PageActions
            content={content}
            showWhishlist={config.settings.showWishlistWidget}
          />
        )}
      </div>
      {content.description && (
        <p className="documentDescription">{content?.description}</p>
      )}
    </div>
  );
};
export default PageHeader;
